const shader = `
#define PRECISION 0.0001
#define MIN_CAMERA_DIST 0.5

attribute float selected;
attribute int gpu_index;
attribute int camera_index;
attribute float visible;

uniform float marker_size;
uniform vec3 camera_position;
uniform bool orbitMode;
uniform vec3 mtrx_x;
uniform vec3 mtrx_y;
uniform vec3 mtrx_z;
uniform float screenHeight;
uniform int currentIndex;
uniform float fov;

varying vec2 vUv;
varying float vSelected;
varying vec4 vGPUColor;
varying float vHidden;
varying float vVisible;

bool compareFloat(float floatOne, float floatTwo) {
    return abs(floatOne - floatTwo) < PRECISION;
}

mat3 scaleMatrix(float scale_x,float scale_y,float scale_z){
    return mat3(
       vec3(scale_x, 0.0, 0.0),
       vec3(0.0, scale_y, 0.0),
       vec3(0.0, 0.0, scale_z)
   );
}

float getDistance3D(vec3 offset) {
    float cam_x = offset.x - camera_position.x;
    float cam_y = offset.y - camera_position.y;
    float cam_z = offset.z - camera_position.z;
    float camera_distance_3d = sqrt(cam_x*cam_x + cam_y*cam_y + cam_z*cam_z);
    return camera_distance_3d;
}

void main() {
    vUv = uv;
    vSelected = selected;
    vGPUColor = makeColor(gpu_index);
    vVisible = visible;

    float hidden = 0.0;
    bool isSelected = compareFloat(vSelected, 1.0);

    float selected_scale = 0.8;
    if (isSelected) {
        selected_scale = 1.0;
    }

    // Global scaling for smaller markers
    selected_scale = 0.5 * selected_scale;

    float x = position.x - (uv.x-0.5);
    float y = position.y - (uv.y-0.5);
    float z = position.z;
    vec3 offset = vec3(x,y,z);

    float distance3D = getDistance3D(offset);
    float height = offset.z - camera_position.z;

    float projFactor = 0.0;
    if (orbitMode) {
        projFactor = getProjFactor(fov, screenHeight, distance3D);
    } else {
        projFactor = getProjFactor(fov, screenHeight, height);
    }

    float markerSize = 30.0 / projFactor;
    markerSize = max(1.0, markerSize);
    markerSize = min(20.0, markerSize);

    float scale_x = markerSize*selected_scale;
    float scale_y = markerSize*selected_scale;
    float scale_z = markerSize*selected_scale;

    // Hide marker based on distance
    if (distance3D < MIN_CAMERA_DIST) {
        hidden = 1.0;
    }

    // Hide the current camera if we arent in orbit mode
    bool currentCamera = currentIndex == camera_index;
    if ((orbitMode == false) && currentCamera) {
        hidden = 1.0;
    }

    // Move position to center of marker
    vec3 pos_offset = position - offset;

    // Rotate using camera quaternion matrix
    mat3 rot = mat3(mtrx_x, mtrx_y, mtrx_z);
    vec3 pos_rotated = pos_offset * rot;

    // Apply scaling based on selected or not
    mat3 scale_matrix = scaleMatrix(scale_x, scale_y, scale_z);
    vec3 pos_scaled = pos_rotated * scale_matrix;

    // Add back our offset values
    vec3 pos_real = pos_scaled + offset;

    // Apply final position
    gl_Position = projectionMatrix * modelViewMatrix * vec4(pos_real, 1.0);

    // We hide the marker for various reasons
    vHidden = hidden;
}
`;

export default shader;